<template>
  <div class="menu-booking">
    <div class="menu-main-action">
      <a-button
        v-for="menuChildItem in menuChildItems"
        :key="menuChildItem.type"
        :class="['menu-button', { active: type === menuChildItem.type }]"
        shape="round"
        @click="changeType(menuChildItem.type)"
        >{{ menuChildItem.name }}</a-button
      >
    </div>
    <common-flight-search-menu
      class="mod-flight-search-box"
      :value="searchParams"
      :type="type"
      :hideMulti="!config.mutipleEnbale"
      :isSupportonlineCity="config.onlineCityEnable"
      :hideTripRadio="false"
      @search="onBookSearch"
    >
    </common-flight-search-menu>
  </div>
</template>
<script>
// import queryString from 'query-string'
import { getFlightSearchParams } from '@/assets/js/util'
export default {
  props: {
    config: {
      type: Object,
      default: () => {
        return {
          jjcEnable: true,
          mutipleEnbale: false,
          onlineCityEnable: false
        }
      }
    }
  },
  computed: {
    menuChildItems () {
      const { jjcEnable } = this.config
      const list = [
        {
          type: 'common',
          name: '机票'
        }
      ]

      if (jjcEnable) {
        list.push({
          type: 'jjc',
          name: '军警残购票'
        })
      }

      return list
    }
  },
  data () {
    return {
      type: 'common',
      searchParams: {},
      mainSettings: window.__MICRO_ROOT__ ?? {}
    }
  },
  methods: {
    changeType (newType) {
      const { type, menuChildItems } = this

      if (newType !== type) {
        this.type = menuChildItems.find(item => item.type !== type).type
      }
    },
    onBookSearch (params) {
      const query = getFlightSearchParams(params)

      // JD - 首航跳转第三方国际票
      // if (this.mainSettings?.airline === 'JD' && query.isInternational) {
      //   window.location.href = queryString.stringifyUrl({ url: `//newuat.jdair.net/jdair#/ticket/tripList`, query })
      //   return
      // }

      window.__MICRO_ROOT__.router?.push({ pathname: '/micro/main/flight/search', query })
    }
  }
}
</script>
